import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {AuthtokenResponse} from "../../model/response/auth/authtoken-response.model";
import {NavigationService} from "../../../service/navigation-service";
import {AuthenticationService} from "../../../service/authentication-service";
import {ModalService} from "../../../service/modal.service";
import {AccessService} from "../../../service/api/access.service";
import {SessionService} from "../../../service/session.service";

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    standalone: false
})
export class NavigationComponent implements OnInit {

  @Input("isAdmin") isAdmin: boolean = false;

  @Output('openSideNav') openSideNav = new EventEmitter()

  isLightNav: boolean;
  navBarOpen: boolean;
  user: AuthtokenResponse
  loggedUserName: string

  menuItems: MenuItem []
  menuNavigationItems: MenuItem []
  menuCompleteItems: MenuItem []

  constructor(
    private navigationService: NavigationService,
    private authService: AuthenticationService,
    private sessionService: SessionService,
    private accesService: AccessService,
    private modalService: ModalService,
    private router: Router) {
  }

  setLogoSource() {
    return this.isLightNav ? '/assets/img/logo_preto.svg' : '/assets/img/logo_branco.svg'
  }

  ngOnInit() {

    this.menuItemInit()
    this.menuNavigationItemsInit()
    this.completeMenuItemInit()


    this.isLightNav = this.navigationService.isLightTheme;
    this.navigationService.navChanged.subscribe(value => {
      this.isLightNav = value
    });

    this.authService._user.subscribe((value: AuthtokenResponse) => {
      this.user = value
    })
    this.navBarOpen = false;

    this.sessionService.getDisplayName()
    this.sessionService._displayName.subscribe({
      next: value => {
        this.loggedUserName = value
      }
    })

  }

  setBackground() {
    let bg = this.isLightNav ? 'bg-white' : 'bg-sky-900'
    if (this.isAdmin) bg = 'bg-transparent'
    return bg
  }

  setShadow() {
    return this.isAdmin ? " " : "shadow"
  }

  setTextColor() {
    return this.isLightNav ? 'text-gray' : 'text-white'
  }

  toggleSideNav() {
    this.openSideNav.emit()
  }

  onLogout() {
    setTimeout(() => {
      this.modalService.simpleConfirmation({
        message: "Tem certeza que deseja terminar a sessão?"
      }).then(confirmed => {
        if (!confirmed) {
          return
        }
        this.accesService.logout()
        this.navigateTo("/acesso")
      })
    })
  }

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated()
  }

  navigateTo(uri: string, parameter? : string) {
    if (parameter) {
      this.router.navigate([uri], {
        queryParams: { padrao: parameter }
      }).then();
      return;
    }
    this.router.navigateByUrl(uri).then();
  }

  menuItemInit() {
    this.menuItems = [
      {
        items: [
          {
            visible: !this.isAuthenticated(),
            label: 'Conta',
            icon: 'pi pi-user',
            command: () => this.navigateTo("/acesso")
          },
          {
            visible: this.isAuthenticated(),
            label: 'Perfil',
            icon: 'pi pi-user',
            command: () => this.navigateTo("/perfil")
          },
          {
            visible: this.isAuthenticated(),
            label: 'Terminar Sessão',
            icon: 'pi pi-times',
            command: () => this.onLogout()
          }
        ]
      }
    ];
  }

  menuNavigationItemsInit() {
    this.menuNavigationItems = [
      {
        items: [
          {
            label: 'Pessoas',
            icon: 'pi pi-users',
            command: () => this.navigateTo("/ocorrencias","people")
          },
          {
            label: 'Documentos',
            icon: 'pi pi-id-card',
            command: () => this.navigateTo("/ocorrencias","document")
          },
          {
            label: 'Veiculos',
            icon: 'pi pi-car',
            command: () => this.navigateTo("/ocorrencias","vehicle")
          }, {
            label: 'Diversos',
            icon: 'pi pi-box',
            command: () => this.navigateTo("/ocorrencias","other")
          }
        ]
      }
    ]
  }

  completeMenuItemInit() {
    this.menuCompleteItems = [
      {
        items: [
          ...this.menuItems[0].items,
          {
            label: 'Criar ocorrência',
            icon: 'pi pi-plus',
            command: () => this.navigateTo("/criar")
          },
        ]
      },
      {
        label: 'Navegação',
        items: this.menuNavigationItems[0].items
      },

    ]
  }
}
